import axios from "axios"

const authenticatedAxios = axios.create()

authenticatedAxios.interceptors.request.use((config) => {
    const token = sessionStorage.getItem('access_token')
    if(token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

export default authenticatedAxios